import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {withStyles} from 'material-ui/styles'
import Dialog from 'material-ui/Dialog'
import Slide from 'material-ui/transitions/Slide'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import Stepper, {Step, StepLabel, StepContent} from 'material-ui/Stepper'

import {firstLogin as text} from './text'
import {
  Dialog as DialogHandler,
  Email as EmailHandler,
  Phone as PhoneHandler,
  Step as StepHandler,
  Address as AddressHandler,
} from './actions'

import StepEmail from './StepEmail'
import StepPhone from './StepPhone'
import StepAddress from './StepAddress'

const styles = theme => ({
  dialog: {
    background: '#f7f7f7',
  },
  root: {
    margin: '50px 0',
  },
  logo: {
    margin: '25px 0',
    textAlign: 'center',
  },
  logoImg: {
    width: 150,
  },
  container: {
    maxWidth: 460,
    margin: '0 auto',
    padding: '35px 0 0 0',
    position: 'relative',
  },
  titleContainer: {
    textAlign: 'center',
    padding: theme.spacing.unit,
  },
})

function Transition(props) {
  return <Slide direction="up" {...props} />
}

class FirstLogin extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      open: props.isOpen,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== this.state.open) {
      this.setState({open: nextProps.isOpen})
    }
  }

  handleClose = () => {
    this.setState({
      open: false,
    })
  }

  render() {
    const {classes} = this.props
    return (
      <Dialog
        fullScreen
        open={this.state.open}
        onClose={this.props.handleClose}
        transition={Transition}
        classes={{paper: classes.dialog}}
      >
        <div className={classes.root}>
          <div className={classes.logo}>
            <img src="/assets/logo.png" alt="logo" className={classes.logoImg}/>
          </div>
          <Paper className={classes.container}>
            <form noValidate autoComplete="off">
              <div className={classes.titleContainer}>
                <Typography variant="title">{text.completeYourInfo}</Typography>
              </div>
              <Stepper activeStep={this.props.step} orientation="vertical">

                <Step key="stepEmail">
                  <StepLabel>{text.email}</StepLabel>
                  <StepContent>
                    <StepEmail
                      handleBackButtonClick={this.handleClose}
                      handleNextButtonClick={this.props.checkEmail}
                      loading={this.props.emailLoading}
                    />
                  </StepContent>
                </Step>

                <Step key="stepPhone">
                  <StepLabel>{text.phone}</StepLabel>
                  <StepContent>
                    <StepPhone
                      handleBackButtonClick={this.props.goBack}
                      handleNextButtonClick={this.props.checkPhoneNumber}
                      loading={this.props.phoneNumberLoading}
                      dialogIsOpen={this.props.phoneDialogIsOpen}
                      closeDialog={this.props.closeSMSDialog}
                      handleCheckButtonClick={this.props.checkPhoneCode}
                      isChecking={this.props.phoneCodeLoading}
                    />
                  </StepContent>
                </Step>

                <Step key="stepAddress">
                  <StepLabel>{text.address}</StepLabel>
                  <StepContent>
                    <StepAddress
                      handleBackButtonClick={this.props.goBack}
                      handleNextButtonClick={this.props.checkAddress}
                      loading={this.props.addressLoading}
                    />
                  </StepContent>
                </Step>

              </Stepper>
            </form>
          </Paper>
        </div>
      </Dialog>
    )
  }
}

FirstLogin.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  step: PropTypes.number,
  checkEmail: PropTypes.func,
  goBack: PropTypes.func,
  checkPhoneNumber: PropTypes.func,
  checkPhoneCode: PropTypes.func,
  closeSMSDialog: PropTypes.func,
  checkAddress: PropTypes.func,
}

const mapStateToProps = state => {
  const firstLogin = state.firstLogin
  return {
    step: firstLogin.step,
    emailLoading: firstLogin.email.isChecking,
    emailError: firstLogin.email.error,
    phoneNumberLoading: firstLogin.phone.isCheckingNumber,
    phoneCodeLoading: firstLogin.phone.isCheckingCode,
    phoneNumberError: firstLogin.phone.numberError,
    phoneCodeError: firstLogin.phone.codeError,
    phoneDialogIsOpen: firstLogin.phone.showDialog,
    addressLoading: firstLogin.address.isChecking,
    addressError: firstLogin.address.error,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeDialog: () => dispatch(DialogHandler.hide()),
    goBack: () => dispatch(StepHandler.goBack()),
    checkEmail: email => dispatch(EmailHandler.checkEmail(email)),
    checkPhoneNumber: number => dispatch(PhoneHandler.checkNumber(number)),
    checkPhoneCode: code => dispatch(PhoneHandler.checkCode(code)),
    closeSMSDialog: () => dispatch(PhoneHandler.closeSMSCodeDialog()),
    checkAddress: (address, number) => dispatch(AddressHandler.checkAddress(address, number)),
  }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(FirstLogin)
const StyledFirstLogin = withStyles(styles, {withTheme: true})(Container)

export default StyledFirstLogin



// WEBPACK FOOTER //
// ./src/sections/firstlogin/FirstLogin.js